var _path, _path2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgNoEvent = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 42,
    viewBox: "0 0 58 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.8187 15.9469C37.5125 17.1938 38.9094 17.7375 40.2125 17.3719L53 13.7156V32.4844C53 34.5469 51.5937 36.3469 49.5875 36.8531L30.4531 41.6344C29.4969 41.8781 28.5031 41.8781 27.5469 41.6344L8.4125 36.8531C6.40531 36.3469 5 34.5469 5 32.4844V13.7156L17.7875 17.3719C19.0906 17.7375 20.4875 17.1938 21.1813 15.9469L28.9156 3L36.8187 15.9469Z",
    fill: "url(#paint0_linear_545_18625)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M0.61633 8.76565L4.52571 0.948777C4.80977 0.380652 5.42196 0.0525273 6.05289 0.131277L29.0001 2.91565L21.1813 15.9469C20.4876 17.1938 19.0907 17.7375 17.7876 17.3719L2.47539 12.9938C0.669768 12.4782 -0.223389 10.4438 0.61633 8.76565ZM55.522 12.9938L40.2126 17.3719C38.9095 17.7375 37.5126 17.1938 36.8188 15.9469L29.0001 2.91565L51.9501 0.131277C52.5782 0.0525273 53.1876 0.380652 53.4782 0.948777L57.3876 8.76565C58.222 10.4438 57.3313 12.4782 55.522 12.9938Z",
    fill: "url(#paint1_linear_545_18625)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_545_18625",
    x1: 29,
    y1: 3,
    x2: 29,
    y2: 41.8172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D3DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_545_18625",
    x1: 29.0006,
    y1: 0.11969,
    x2: 29.0006,
    y2: 17.4839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D3DA"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgNoEvent);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/no-event.9961b1e69096b0da8e30a73e1b5a9454.svg";